<template>
  
  <div>
    <v-data-table
      dense
      :headers="headers"
      :items="list"
      :hide-default-footer="!pagination"
      :disable-pagination="!pagination"
      @click:row="handleClick"
    >
      <template v-slot:item.Amount="{ item }">
        
        <v-text-field
          outlined
          dense
          hide-details="true"
          v-on:keypress="NumbersOnly"
          :maxlength="6"
          v-model="item.minAmount"
          @change="changeAmount(item)"
          @onChange="checked(item)"
          :disabled="item.Status != 0 && item.Status != 2"
        >
        {{changeAmount(item)}}
        </v-text-field>
        <!-- data-pattern="xxx:xx"
          placeholder="1234 1234 1234 1234" -->
      </template>
      
    </v-data-table>
  </div>
</template>

<script>
import { textMarshal } from "text-marshal";
// import EosUtils from '../../../utils/EosUtils';
export default {
  props: {
    list: Array,
    pagination: {
      type: Boolean,
      default: false,
    },
  },
  watch: {
    list() {
      //debugger
      this.selectedList = [];
    },
    item:function(val) {
      //debugger
     this.item = val;
     
     },
  },
  data() {
    return {
      selectedList: [],
      headers: [
        {
          text: this.$t("card-no"),
          value: "perno",
        },
        {
          text: this.$t("person-name"),
          value: "PersonName",
        },
        {
          text: this.$t("SectionName"),
          value: "SectionName",
        },
        {
          text: this.$t("status"),
          value: "Statustype",
        },
        {
          text: this.$t("specificExtraWork"),
          value: "Amount",
        },
        {
          text: "",
          value: "",
        },
      ],
    };
  },
  methods: {
    handleClick(value) {
      this.$emit("onClick", value);
    },
    changeAmount(item) {
      //debugger;
      
      console.log(item);
      if (!item.minAmount.includes(":")) {

        if(item.minAmount.length>3){
          var aa =item.minAmount.split("");
          aa.splice(-2, 0, ":")
          aa=aa.join('');
          console.log(aa);
          var bb =aa.toString()
          item.minAmount=bb;
          
        }
       
        // item.minAmount = EosUtils.ConvertMinToHour(item.minAmount);
      }
      this.$emit("changeAmount", this.list);
    },
    editInput(){
      const cardnumber = document.getElementById("cardnumber");

    cardnumber.oninput = function (e) {
    let data = textMarshal({
    input: e.target.value,
    template: cardnumber.getAttribute("data-pattern"),
    disallowCharacters: [/[a-z]/],
  });

  cardnumber.value = data.marshaltext;
};
    },
    check(item)
    {
      //debugger
      this.checked(item)
    },
          
    //@click="enterValue(item)"
    // enterValue(item){
    // //debugger
    // item.Amount="";
    // item.minAmount="";
    // },
    NumbersOnly(evt) {
      // //debugger
      evt = (evt) ? evt : window.event;
      var charCode = (evt.which) ? evt.which : evt.keyCode;
      if ((charCode > 31 && (charCode < 48 || charCode > 57)) && charCode !== 46) {
        evt.preventDefault();
      } else {
        this.changeAmount(this.item.minAmount)
        return true;
      }
    },
    checked(item)
    {
      var aa= this.item.minAmount;
       console.log(aa)
      //debugger
      item
    },
   
 
  },
  
};
</script>

<style>
</style>